












import { Prop, Component, Vue } from "vue-property-decorator";

@Component({})
export default class IconBlank extends Vue {
  @Prop({ default: 18 }) private radius!: number;
  @Prop({ default: "" }) alt!: string;

  private get length(): string {
    return `${this.radius * 2}px`;
  }
}
